import {HashConnect} from 'hashconnect'
import { 
    motion,
    useAnimationControls 
  } from "framer-motion"

  import {
    AccountId,
    TokenId,
    TokenAssociateTransaction,
    TopicMessageSubmitTransaction,
    TransferTransaction,
    ScheduleSignTransaction,
    Client,
    PrivateKey,
    Hbar
} from '@hashgraph/sdk'

import {WalletConnectedNoToken,WalletConnectedTokenAssociated,GetNFTavailable,load,loss} from 'pages/Creamies'
import { json } from 'react-router-dom';

const axios = require('axios').default;

let hashconnect = new HashConnect();
const delay = ms => new Promise(res => setTimeout(res, ms));

localStorage.clear();
hashconnect.connectionStatusChangeEvent.once((connectionStatus) => {
    console.log(`connexion status: ${connectionStatus}`)
})

let saveData = {
    topic: "",
    pairingString: "",
    privateKey: "",
    pairedWalletData: null,
    pairedAccounts:[]
}

let isMainnet = true;

let hashConnectString = "testnet";
let mirrornodeString = "testnet";

if(isMainnet){
    hashConnectString = "mainnet";
    mirrornodeString = "mainnet-public"; 
}

const keyTokenId = TokenId.fromString('0.0.1385462');
const heavenaspirantTokenId = TokenId.fromString('0.0.2125331');
const infinityjarTokenId = TokenId.fromString('0.0.1881189');
const creamutilitycardTokenId = TokenId.fromString('0.0.1321477');

//const tokengatedID = foundercardTokenId;


const operatorId = AccountId.fromString("0.0.1380960");

let account_save = ""

let serial = 0;

const WLlist = [
    "0.0.1157105",
    "0.0.1266223",
    "0.0.1742830",
    "0.0.181993",
    "0.0.639006",
    "0.0.618311"
]

const BL =[
    "0.0.1765052",
    "0.0.2004129",
    "0.0.2004154",
    "0.0.2004157",
    "0.0.2004185",
    "0.0.2004186",
    "0.0.2004199",
    "0.0.2004201",
    "0.0.2004332",
    "0.0.2004337",
    "0.0.2004350",
    "0.0.2013955",
    "0.0.2174854",
    "0.0.2174860",
    "0.0.1116280",
    "0.0.1116299",
    "0.0.1674539",
    "0.0.1697283",
    "0.0.738170",
    "0.0.1257294",
    "0.0.1257326",
    "0.0.2000618",
    "0.0.2018852",
    "0.0.1025968",
    "0.0.1044659",
    "0.0.1047698",
    "0.0.1050108",
    "0.0.1701729",
    "0.0.1693936",
    "0.0.2483952",
    "0.0.1157853",
    "0.0.1297003",
    "0.0.2013421",
    "0.0.2159591",
    "0.0.1443929",
    "0.0.1971252",
    "0.0.2013443",
    "0.0.2159587",
    "0.0.771060",
    "0.0.1467839",
    "0.0.1971175",
    "0.0.2158490",
    "0.0.2158461",
    "0.0.1971229",
    "0.0.1972055",
    "0.0.2003033",
    "0.0.2157295",
    "0.0.2003048",
    "0.0.1765052",
    "0.0.2004129",
    "0.0.2004154",
    "0.0.2004157",
    "0.0.2004185",
    "0.0.2004186",
    "0.0.2004199",
    "0.0.2004201",
    "0.0.2004332",
    "0.0.2004337",
    "0.0.2004350",
    "0.0.2013955",
    "0.0.2174854",
    "0.0.2174860",
    "0.0.2483952",
    "0.0.1876282",
    "0.0.1884010",
    "0.0.1895620",
    "0.0.1884078",
    "0.0.2020815",
    "0.0.1761977",
    "0.0.2572172",
    "0.0.1664809",
    "0.0.2129500",
    "0.0.1674529",
    "0.0.1714466",
    "0.0.1721775",
    "0.0.2080695",
    "0.0.2080693",
    "0.0.2080702",
    "0.0.2080709",
    "0.0.2080715",
    "0.0.2080732",
    "0.0.2080733",
    "0.0.2080736",
    "0.0.2080740",
    "0.0.2080741",
    "0.0.1391021",
    "0.0.1297003",
    "0.0.2013421",
    "0.0.2159591",
    "0.0.1443929",
    "0.0.1971252",
    "0.0.2013443",
    "0.0.2159587",
    "0.0.1467839",
    "0.0.1971175",
    "0.0.2158490",
    "0.0.2158461",
    "0.0.1971229",
    "0.0.1972055",
    "0.0.2003033",
    "0.0.2157295",
    "0.0.2003048",
    "0.0.2155781",
    "0.0.2155786"
]

const appMetaData = {
    name: 'Legends of the past',
    description: 'Welcome mortals to the heaven of Legends, hope you are well, here you can exchange your Heaven Key against the Infinity jar, a jar that will give you lot of things.',
    icon:'https://gateway.pinata.cloud/ipfs/QmT3CfPxyfW381YaMXJqdqYsVvAyrszj5TMiYGucMVZ6Wk'
}

let connected = false;
export const pairHashpack = async () => {

    if(connected){
        return;
    }

    let initData = await hashconnect.init(appMetaData,hashConnectString,false)
    saveData.privateKey = initData.privKey
    saveData.topic = initData.topic

    console.log('initData')
    console.log(initData)
    console.log(`topic: ${initData.topic}`)

    hashconnect.foundExtensionEvent.once((walletMetadata)=>{
        hashconnect.connectToLocalWallet(initData.pairingString,walletMetadata)
    })

    hashconnect.pairingEvent.once((pairingData) => {
        console.log(`wallet paired`)
        console.log(pairingData)

        const accountId = document.getElementById('accountid');
        accountId.innerHTML = pairingData.accountIds[0];
        account_save = pairingData.accountIds[0];
        connected = true;
        //account_save = "0.0.618311"
        //account_save = "0.0.2311470"
        //account_save = "0.0.2199036"
        //account_save = "0.0.1765052"
        saveData.pairedAccounts.push(pairingData.accountIds[0]);
        CheckAccountHasCream();
        //checkWL(pairingData.accountIds[0])
    })
    
    return initData;
}

export const CheckAccountHasCream = async() => {

    let creamToken = "0.0.926385";
    if(WLlist.includes(account_save)){
        console.log("WL user");
        CheckAssociateToken();
        return;
    }

    if(BL.includes(account_save)){
        console.log("BL user");
        show_text("this account is banned")
        return;
    }

    //https://mainnet-public.mirrornode.hedera.com/api/v1/tokens/0.0.926385/balances?account.id=0.0.1157105
    const url = `https://`+mirrornodeString+`.mirrornode.hedera.com/api/v1/tokens/${creamToken}/balances?account.id=${account_save}`;
    //const url = `https://testnet.mirrornode.hedera.com/api/v1/tokens/${keyTokenId}/nfts?account.id=0.0.48508695`;
    let res= false;
	await axios
		.get(url)
		.then(function (response) {
			const jsonResponse = response.data;
            // output the from address and message stored in the event
            if (jsonResponse.balances.length !==0 && jsonResponse.balances[0].balance >= 10000){
                CheckAssociateToken();
            }
            else{
                WalletConnectedNoToken();
            }
            
		})
		.catch(function (err) {
			console.error(err);
            alert(err.toString());
		});
    return res
}

let nft_available = 1;

//make the diff with last Heaven Key serial(400 => 385) 385 exclu 15 Heaven Key
//make the diff with last Heaven Key serial(325 => 310) 310 exclu 15 Heaven Key
//make the diff with last Heaven Key serial(334 => 325) 325 exclu 9 Heaven Key
//make the diff with last Heaven Key serial(335 => 350) 335 exclu
//make the diff with last Heaven Key serial(330 => 335) 330 exclu
//make the diff with last Heaven Key serial(346 => 350) 335 exclu
//896,897,898,899 Heaven Aspirant (899 => 895) 895 exclu
//895,894,893,892,891,890,889,888,887,886,885,884,883,882,881 Heaven Aspirant (895 => 880) 880 exclu
export const AskSupplyAndUpdateVisual= async () => 
{
    const url = `https://`+mirrornodeString+`.mirrornode.hedera.com/api/v1/tokens/${keyTokenId}/nfts?account.id=${operatorId}`
    //if we have a response => break transaction because we don't have NFT to give 

    let last_serial = 400;
    axios
		.get(url)
		.then(function (response) {
            const jsonResponse = response.data;

            last_serial = parseInt(jsonResponse.nfts[0]["serial_number"])
            //console.log(`${last_serial} last serial`);
            nft_available = last_serial - 385;
            //TODO to delete
            //nft_available = 15
            GetNFTavailable(nft_available);
            

            if(nft_available >= 0){
                //console.log(`${nft_available} NFT are still available`);
            }
            else{
                //console.log('NFT are all sold');
            }
            document.getElementById("supplyLoadingBar").style.width =(nft_available*100/15).toString()+"%";
            document.getElementById("supplyText").innerHTML = nft_available.toString()+"/15";
		})
		.catch(function (err) {
            console.log(`error: ${err}`);
		})
    await delay(1000); //5 seconds
    AskSupplyAndUpdateVisual();
}

const TimeStart = async () =>{
    const startGameDate = new Date(2023,5,15,19,0,0,0);
    const url = "https://sh71h1oegb.execute-api.eu-west-2.amazonaws.com/default/GetTime";

    console.log("startGameDate: "+startGameDate);

    axios
		.get(url)
		.then(function (response) {
			const jsonResponse = response.data;
            console.log("date: "+jsonResponse);
            let month = jsonResponse.substring(0,2)
            let day = jsonResponse.substring(3,5)
            const dateAnswer = new Date(day+"/"+month+jsonResponse.substring(5));
            console.log("date format: "+dateAnswer.toString());

            let diff = startGameDate - dateAnswer
            console.log("diff: "+diff)

            if(diff<= 1000){
                WalletConnectedTokenAssociated();
            }
            else{
                startGameTimer(diff);
            }

            
		})
		.catch(function (err) {
			console.error(err);
            alert(err.toString());
		}); 
  
    //WalletConnectedTokenAssociated();
  
  }

const startGameTimer = async(diff) => {

    const response = document.getElementById('response');
    while(diff > 1000){
        
        response.innerHTML = `${formatTime(diff/1000)} seconds before the game start`;
        await delay(1000);
        diff = diff -1000
    }

    WalletConnectedTokenAssociated();

}

function formatTime(seconds) {
    var days = Math.floor(seconds / (24*60*60));
    var hours = Math.floor(seconds % (24*60*60) / (60*60));
    var minutes = Math.floor(seconds % (60*60) / 60);
    var seconds = Math.floor(seconds % 60);

    var result = "";
    if(days > 0) {
        if (days < 10) days = "0" + days;
        result += days + ":";
    }

    if(hours > 0 || days > 0) {
        if (hours < 10) hours = "0" + hours;
        result += hours + ":";
    }

    if (minutes < 10) minutes = "0" + minutes;
    result += minutes + ":";

    if (seconds < 10) seconds = "0" + seconds;
    result += seconds;

    return result;
}

export const CheckAssociateToken = async(bool) => {
    const url = `https://`+mirrornodeString+`.mirrornode.hedera.com/api/v1/accounts/${account_save}/tokens?token.id=${keyTokenId}`;

    //TODO try catch
    axios
		.get(url)
		.then(function (response) {
			const jsonResponse = response.data;
            if (jsonResponse.tokens.length == 0){
                return AssociateToken();
            }
            else{
                console.log(`token ${keyTokenId} is already associated`);
                CheckAssociateTokenCream();
            }
            
		})
		.catch(function (err) {
			console.error(err);
            alert(err.toString());
		}); 
}

export const CheckAssociateTokenCream = async(bool) => {
    const url = `https://`+mirrornodeString+`.mirrornode.hedera.com/api/v1/accounts/${account_save}/tokens?token.id=${creamutilitycardTokenId}`;

    //TODO try catch
    axios
		.get(url)
		.then(function (response) {
			const jsonResponse = response.data;
            if (jsonResponse.tokens.length == 0){
                return AssociateTokenCream();
            }
            else{
                console.log(`token ${creamutilitycardTokenId} is already associated`);
                TimeStart();
            }
            
		})
		.catch(function (err) {
			console.error(err);
            alert(err.toString());
		}); 
}

export const AssociateToken = async() => {
    try {
        const provider = hashconnect.getProvider(hashConnectString, saveData.topic, AccountId.fromString(account_save))
        const signer = hashconnect.getSigner(provider)
        let associateLocalWalletTx = await new TokenAssociateTransaction()
            .setAccountId(AccountId.fromString(account_save))
            .setTokenIds([keyTokenId])
            .setMaxTransactionFee(new Hbar(150))

            .freezeWithSigner(signer);

        let associateLocalWalletTxSubmit = await associateLocalWalletTx.executeWithSigner(signer);
        if (associateLocalWalletTxSubmit == undefined){
            console.log(`user refuse to associate token`);
        }
        else{
            CheckAssociateTokenCream();
        }
    } catch (error) {
        console.log(`error token don't associated: ${error}`);
    }
}

export const AssociateTokenCream = async() => {
    try {
        const provider = hashconnect.getProvider(hashConnectString, saveData.topic, AccountId.fromString(account_save))
        const signer = hashconnect.getSigner(provider)
        let associateLocalWalletTx = await new TokenAssociateTransaction()
            .setAccountId(AccountId.fromString(account_save))
            .setTokenIds([creamutilitycardTokenId])
            .setMaxTransactionFee(new Hbar(150))

            .freezeWithSigner(signer);

        let associateLocalWalletTxSubmit = await associateLocalWalletTx.executeWithSigner(signer);
        if (associateLocalWalletTxSubmit == undefined){
            console.log(`user refuse to associate token`);
        }
        else{
            TimeStart();
        }
    } catch (error) {
        console.log(`error token don't associated: ${error}`);
    }
}

let askServer = false;
export const AskServerToSendKey = async() => {
    //post request 
    if (askServer) {
        delay(2000);
        show_text("already ask server!")
        return;
    }
    askServer = true;
    //launch anim ?

    if (nft_available <= 0) {
        loss();
        return;
    }

    console.log("walletid="+account_save);

    axios
        .get("https://c9grcgr3s1.execute-api.eu-west-2.amazonaws.com/default/redirectEC2?walletid="+account_save+"&target=game")
        .then(function (response) {
            console.log(response);
			const jsonResponse = response.data;
            console.log(jsonResponse);
            show_text(JSON.parse(jsonResponse.replace(/'/g,'"'))["status"]);
            //OnSendKey();
            /*if (jsonResponse["status"] === "sending the key") {
                console.log("Receive Key");
                
            }*/
            
		})
		.catch(function (err) {
			console.log(err);
            alert(err.toString());
		});
}

export const show_text = (message)=>{

    if (message.includes("wallet")) {
        load();
    }
    else{
        loss();
    }

    let text = document.getElementById("text_key");
    text.className = "italic opacity-100 text-white z-50 mx-8 lg:mx-0 h-10 text-[0.8rem] lg:text-[1.2rem] mt-4 font-bold";
    text.innerHTML = message;
}